import React from 'react';
import { render } from 'react-dom';

const ConfirmLabTest = (
  label,
  onYes,
  onNo,
  options = { yesLabel: 'Yes', noLabel: 'No' },
  withRemarks,
  laboratory
) => {
  const rootElement = document.getElementById('my-confirm-modal');
  const stool_approve = 'NO OVA OR PARASITES SEEN';
  const sputum_approve = 'N/A';
  const drug_test_approve = `METHAMPHETAMINE - NEGATIVE - PASSED\nTETRAHYDROCANNABINOL - NEGATIVE - PASSED`;

  const handleYes = () => {
    const remarks = document.getElementById('remarks').value;
    if (onYes) {
      if (document.getElementById('remarks')) {
        onYes(remarks);
      } else {
        onYes();
      }
    }
    render(<div id="my-confirm-modal" />, rootElement);
  };

  const handleNo = () => {
    if (onNo) {
      onNo();
    }
    render(<div id="my-confirm-modal" />, rootElement);
  };

  const getRemarks = (name) => {
    let defaultRemarks = '';
    switch (name) {
      case 'Stool':
        defaultRemarks = stool_approve;
        break;
      case 'Sputum':
        defaultRemarks = sputum_approve;
        break;
      case 'Drug Test':
        defaultRemarks = drug_test_approve;
        break;
      default:
        defaultRemarks = '';
        break;
    }
    return defaultRemarks;
  };

  render(
    <div>
      <div style={{ position: 'absolute' }}>
        <div
          className="modal show"
          style={{
            display: 'block',
            zIndex: 1051,
            backgroundColor: 'rgba(0, 0, 0, .6)',
            pointerEvents: 'none',
          }}
        >
          <div className="modal-dialog" style={{ pointerEvents: 'initial' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirmation</h4>
              </div>
              <div className="modal-body">
                <label>{label}</label>
                {withRemarks && (
                  <div className="form-group">
                    <label>Remarks: </label>
                    <textarea id="remarks" className="form-control" rows={15}>
                      {getRemarks(laboratory)}
                    </textarea>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary "
                  onClick={handleYes}
                >
                  {options.yesLabel}
                </button>{' '}
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={handleNo}
                >
                  {options.noLabel}
                </button>
              </div>
            </div>
          </div>
        </div>
        {
          // eslint-disable-next-line
          <div
            className="modal-backdrop fade show"
            style={{ zIndex: 1050, pointerEvents: 'initial' }}
            onClick={handleNo}
          />
        }
      </div>
    </div>,
    rootElement
  );
};

export default ConfirmLabTest;
